export const ROOT = '/';
export const DASHBOARD_URL = '/dashboard';

//General
export const COUNTRY_ID = ':id/:type';
//Auth
export const ROUTE_AUTH_BASE = 'auth';
export const ROUTE_AUTH_FULL_PATH = `/${ROUTE_AUTH_BASE}`;
export const ROUTE_REGISTER = 'register';
export const ROUTE_FORGET_PASSWORD = 'forgot-password';
export const ROUTE_AUTH_URL = `${ROUTE_AUTH_BASE}/*`;

//Profile
export const PROFILE_FULL_PATH = '/profile';
export const PROFILE_BASE_URL = 'profile';
export const PROFILE_URL = `${PROFILE_BASE_URL}/*`;

//Orders
export const ORDERS_FULL_PATH = '/orders';
export const ORDERS_BASE_URL = 'orders';
export const ORDERS_URL = `${ORDERS_BASE_URL}/*`;

//Cart
export const CART_FULL_PATH = '/cart';
export const CART_BASE_URL = 'cart';
export const CART_URL = `${CART_BASE_URL}/*`;

//Sim Management
export const SIM_MANAGEMENT_FULL_PATH = '/sim-management';
export const SIM_MANAGEMENT_BASE_URL = 'sim-management';
export const SIM_MANAGEMENT_URL = `${SIM_MANAGEMENT_BASE_URL}/*`;

//Referral
export const REFERRAL_FULL_PATH = '/referral';
export const REFERRAL_BASE_URL = 'referral';
export const REFERRAL_URL = `${REFERRAL_BASE_URL}/*`;
